type ExitIntentConfirmation = {
  message?: string;
  callback: () => void;
};

export const exitIntentConfirmation = ({
  message = 'Are you sure you want to leave this page without completing your setup?',
  callback,
}: ExitIntentConfirmation) => {
  const isConfirmed = window.confirm(message); // eslint-disable-line no-alert
  if (!isConfirmed) return null;
  return callback?.();
};

function preventDefaultExitNotification(e: BeforeUnloadEvent) {
  e.preventDefault();
}

export const windowExitNotification = () => {
  window.addEventListener('beforeunload', preventDefaultExitNotification);
};

export const removeWindowExitNotification = () => {
  window.removeEventListener('beforeunload', preventDefaultExitNotification);
};
